import React from 'react';

const GraduationCap = () => {
    return (
        <svg viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1783_371)">
                <path
                    d="M21.6677 19.8581C22.4035 19.8581 23 19.2548 23 18.5106C23 17.7664 22.4035 17.1631 21.6677 17.1631C20.9319 17.1631 20.3354 17.7664 20.3354 18.5106C20.3354 19.2548 20.9319 19.8581 21.6677 19.8581Z"
                    fill="#006FFF"/>
                <path
                    d="M3.64636 8.93604L3.67722 14.6169C3.67722 15.5843 3.86935 17.268 4.76831 17.7616C7.1749 19.0864 12.5126 20.38 16.7339 17.8211C17.7002 17.2353 18.2696 16.2297 18.2654 15.1616C18.2584 13.0339 18.292 9.38001 18.292 9.38001"
                    stroke="url(#paint0_linear_1783_371)" strokeWidth="2" strokeLinecap="round"
                    strokeLinejoin="round"/>
                <path d="M20.6158 7.65942L21.7378 6.9502V15.4608" stroke="#006FFF" strokeWidth="2" strokeLinecap="round"
                      strokeLinejoin="round"/>
                <path d="M11.5 0.708984L0.701233 7.09196L11.3598 13.3331L21.7378 6.95012L11.5 0.708984Z"
                      stroke="url(#paint1_linear_1783_371)" strokeWidth="2" strokeLinecap="round"
                      strokeLinejoin="round"/>
            </g>
            <defs>
                <linearGradient id="paint0_linear_1783_371" x1="2.94514" y1="14.1133" x2="18.9933" y2="14.1133"
                                gradientUnits="userSpaceOnUse">
                    <stop offset="0.2" stopColor="#03E4B3"/>
                    <stop offset="1" stopColor="#007FF1"/>
                </linearGradient>
                <linearGradient id="paint1_linear_1783_371" x1="1.33514e-05" y1="7.02104" x2="22.439" y2="7.02104"
                                gradientUnits="userSpaceOnUse">
                    <stop offset="0.2" stopColor="#03E4B3"/>
                    <stop offset="1" stopColor="#007FF1"/>
                </linearGradient>
                <clipPath id="clip0_1783_371">
                    <rect width="23" height="20" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default GraduationCap;
